import {
	Box,
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography,
	useMediaQuery
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import React from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroup, setState } from "../scenarioSetupNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function SkuPgSearchForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const {
		skuCategories,
		selectedSKUCategory,
		sku_PG_Name,
		selectedCountry,
		countryID,
	} = setupState;
	const isTab = useMediaQuery("(max-width: 800px)");
	const handleSKUCategorySelection = (event) => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("selectedSKUCategory", value));
	};

	const handleSearchPG = () => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country first", "info");
			return;
		}
		dispatch(setState("productGroups", []));
		dispatch(getProductGroup({ countryID, sku_PG_Name }));
	};

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box
			sx={{
				mt: 4,
			}}
		>
			{/* <Box>
				<Typography variant="subtitle1" sx={{ color: "lightBlue.main", fontWeight: "bold", mb:4, }} className="compHeading">
					Select SKUs/Product Groups
				</Typography>
			</Box> */} 
			<Grid container spacing={2}>
			<Grid item xs={12} md={5.4} lg={11.5}>
					<Box>
						<FormControl fullWidth>
							<InputLabel id="demo-simple-select-label">
								Select SKU Category
							</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedSKUCategory}
								label="Country"
								onChange={handleSKUCategorySelection}
								className="montserratFont"
							>
								{skuCategories.map((category, index) => {
									return (
										<MenuItem key={index} value={category}>
											{category}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>
				<Grid item xs={12} md={5.4} lg={11.5}>
					<Box>
						<TextField fullWidth
							id="outlined-basic"
							label="SKU / Product Group"
							variant="outlined"
							size="small"
							value={sku_PG_Name}
							onChange={(event) =>
								handleStateUpdate(event, "sku_PG_Name")
							}
							InputProps={{ autoComplete: "off" }}
						/>
					</Box>
					</Grid>
					<Grid item xs={12} md={5.4} lg={11.5}>
					<Box >
						<Button
							startIcon={<SearchIcon />}
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								"&:hover": {
									bgcolor: "darkred.main",
								},
								float: "right",
							}}
							onClick={handleSearchPG}
						>
							Search
						</Button>
					</Box>
					</Grid>
					</Grid>
		</Box>
	);
}
